import { Component, OnInit, TemplateRef } from "@angular/core";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "app/auth/service";
import { ListService } from "app/auth/service/list.service";
import { UtilsService } from "app/auth/service/utils.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";
import { ICompanyOffice } from "./company-office.interface"; // Import the new interface

@Component({
  selector: "app-company-office-list",
  templateUrl: "./company-office-list.component.html",
})
export class CompanyOfficeListComponent implements OnInit {
  public contentHeader: IContentHeader;
  private list_type: string = "company_office"; // Changed list_type
  public companyOffices = []; // Changed variable name
  public filteredCompanyOffices = []; // Changed variable name
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public showModalError: boolean = false;
  public typeForm: ICompanyOffice = { // Using the new interface
    id: null,
    name: null,
    other: {
      address: null,
      contract_string: null,
      coordinates: null,
    },
  };

  constructor(
    public listService: ListService,
    private _routerService: Router,
    public _authenticationService: AuthenticationService,
    public _utilService: UtilsService,
    private _modalService: NgbModal,
  ) {
    this.contentHeader = {
      headerTitle: "MENU.COMPANY_OFFICES", // New translation key
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.RECRUITMENT", // Assuming "Recruitment" is the parent menu
            isLink: true,
            link: "/dashboard/recruitment", // Adjust link if needed
          },
          {
            name: "MENU.COMPANY_OFFICES", // New translation key
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("show_company_office_list")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }
    this.load();
  }

  load() {
    this.listService.getList(this.list_type).then((result: any) => {
      this.companyOffices = result; // Assign to new variable
      this.filterCompanyOffices(); // Call new filter method
    });
  }

  modalOpen(modal: TemplateRef<any>, selectedType: ICompanyOffice) { // Using ICompanyOffice
    this._modalService.open(modal, {
      size: "md",
      centered: true,
    });
    this.typeForm = { // Reset typeForm
      id: null,
      name: null,
      other: {
        address: null,
        contract_string: null,
        coordinates: null,
      },
    };
    if (selectedType) {
      // Deep copy to avoid direct manipulation of the object in the list
      this.typeForm = JSON.parse(JSON.stringify(selectedType));
    }
    this.showModalError = false;
  }

  filterCompanyOffices() { // New method name
    const key: string = this.searchKeyword.trim().toLowerCase();
    let filterItem: ICompanyOffice[] = this.companyOffices; // Use ICompanyOffice
    if (key.length > 0) {
      filterItem = filterItem.filter(
        (item: ICompanyOffice) =>
          item.name.toLowerCase().trim().includes(key) ||
          item.other.address.toLowerCase().trim().includes(key) ||
          item.other.contract_string.toLowerCase().trim().includes(key) ||
          (item.other.coordinates && item.other.coordinates.toLowerCase().trim().includes(key))
      );
    }
    this.filteredCompanyOffices = filterItem; // Assign to new variable
  }

  isError(): boolean {
    this.showModalError =
      this.typeForm.name === null || this.typeForm.name.length < 1 ||
      this.typeForm.other.address === null || this.typeForm.other.address.length < 1 ||
      this.typeForm.other.contract_string === null || this.typeForm.other.contract_string.length < 1;
    return this.showModalError;
  }

  async addType() {
    if (!this._authenticationService.hasCapability("create_company_office")) { // New capability
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    delete this.typeForm.id; // id is auto-generated by backend

    this._utilService.showLoading();
    await this.listService
      .create(this.typeForm, this.list_type)
      .then(() => {
        this._modalService.dismissAll();
        this.load();
        this._utilService.hideLoading();
        this._utilService.showToastrSuccess("SUCCESS_ADD_COMPANY_OFFICE");
        this.typeForm = { // Reset form
          id: null,
          name: "",
          other: {
                      address: "",
                      contract_string: "",
                      coordinates: "",
            
          },
        };
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showToastrError("ERROR_ADD_COMPANY_OFFICE");
      });
  }

  async editType() {
    if (!this._authenticationService.hasCapability("edit_company_office")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    const idType: number = this.typeForm.id;
    delete this.typeForm.id;

    this._utilService.showLoading();
    await this.listService
      .update(idType, this.typeForm, this.list_type)
      .then(() => {
        this._modalService.dismissAll();
        this.load();
        this._utilService.hideLoading();
        this._utilService.showToastrSuccess("SUCCESS_EDIT_COMPANY_OFFICE");
        this.typeForm = { // Reset form
          id: null,
          name: null,
          other: {
            address: null,
            contract_string: null,
          },
        };
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showToastrError("ERROR_EDIT_COMPANY_OFFICE");
      });
  }

  async deleteType(selectedType: ICompanyOffice) {
    if (!this._authenticationService.hasCapability("delete_company_office")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += selectedType.name;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this.listService.delete(selectedType.id, this.list_type).then(() =>
            this._utilService.showPopupItemDeleted().then(async () => {
              this.load();
              await this._utilService.showToastrSuccess("SUCCESS_DELETE_COMPANY_OFFICE");
            }),
          );
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => this._utilService.showToastrError("ERROR_DELETE_COMPANY_OFFICE"));
  }
}